// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

import Auth from '../../../services/auth/Auth';
import { logoutUser } from '../../../services/auth/requests';

class Logout extends React.Component<RouteComponentProps> {
  public componentDidMount(): void {
    logoutUser()
      ?.then(() => {
        /* pass */
      })
      .catch(() => {
        /* pass */
      })
      .finally(() => {
        Auth.deauthenticateUser(true);
      });
  }

  public render(): React.ReactNode {
    return null;
  }
}

export default withRouter(Logout);
